import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SEOHead from "../components/SEOHead";
import { getSitemapData } from "../lib/api";

export default function Sitemap() {
    const [data, setData] = useState({ locations: [], cities: [], blog: [] });

    useEffect(() => {
        getSitemapData().then(setData);
    }, []);

    const grouped = data.cities.reduce((acc, c) => {
        const k = c.city[0].toUpperCase();
        (acc[k] = acc[k] || []).push(c);
        return acc;
    }, {});

    return (
        <>
            <SEOHead
                title="Sitemap — All Pages & Neighborhoods"
                description="Complete index of weeddispensarynearme.com — every ZenZest location, every neighborhood, every guide."
                canonical="https://weeddispensarynearme.com/sitemap"
            />
            <section className="border-b border-zen-ink/8 bg-zen-bg">
                <div className="max-w-[1400px] mx-auto px-6 sm:px-10 py-14">
                    <p className="text-[11px] uppercase tracking-[0.35em] text-zen-olive mb-6">
                        Sitemap
                    </p>
                    <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl font-light text-zen-ink leading-[0.95] tracking-tight max-w-3xl">
                        Every page,{" "}
                        <span className="italic text-zen-olive">indexed.</span>
                    </h1>
                </div>
            </section>

            <section className="bg-zen-bg max-w-[1400px] mx-auto px-6 sm:px-10 py-14">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-16 mb-20">
                    <div>
                        <p className="text-[11px] uppercase tracking-[0.3em] text-zen-olive mb-5">
                            Stores
                        </p>
                        <ul className="space-y-3">
                            {data.locations.map((l) => (
                                <li key={l.slug}>
                                    <Link
                                        to={`/locations/${l.slug}`}
                                        className="text-zen-ink hover:text-zen-olive"
                                    >
                                        {l.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div>
                        <p className="text-[11px] uppercase tracking-[0.3em] text-zen-olive mb-5">
                            Pages
                        </p>
                        <ul className="space-y-3 text-zen-ink">
                            <li>
                                <Link to="/" className="hover:text-zen-olive">
                                    Home — find a dispensary near me
                                </Link>
                            </li>
                            <li>
                                <Link to="/locations" className="hover:text-zen-olive">
                                    All locations
                                </Link>
                            </li>
                            <li>
                                <Link to="/blog" className="hover:text-zen-olive">
                                    The Journal
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <p className="text-[11px] uppercase tracking-[0.3em] text-zen-olive mb-5">
                            Journal
                        </p>
                        <ul className="space-y-3">
                            {data.blog.map((p) => (
                                <li key={p.slug}>
                                    <Link
                                        to={`/blog/${p.slug}`}
                                        className="text-zen-ink hover:text-zen-olive"
                                    >
                                        {p.title}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                <p className="text-[11px] uppercase tracking-[0.3em] text-zen-olive mb-8">
                    Dispensary near · {data.cities.length} neighborhoods
                </p>
                <div className="space-y-10">
                    {Object.keys(grouped)
                        .sort()
                        .map((letter) => (
                            <div key={letter}>
                                <p className="font-serif text-3xl text-zen-olive font-light mb-5">
                                    {letter}
                                </p>
                                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-x-6 gap-y-2">
                                    {grouped[letter].map((c) => (
                                        <Link
                                            key={c.slug}
                                            to={`/dispensary-near/${c.slug}`}
                                            data-testid={`sitemap-city-${c.slug}`}
                                            className="text-sm text-zen-ink hover:text-zen-olive"
                                        >
                                            {c.city}{" "}
                                            <span className="text-[11px] text-zen-muted">
                                                {c.zip}
                                            </span>
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        ))}
                </div>
            </section>
        </>
    );
}
